export default "__VITE_ASSET__BOdMrB3H__"